<div class="form-container pt">
    <div class="thanks">
        <div class="thanks-heading">
            Thank You
        </div>
        <div class="thanks-content" *ngIf="status == STATUS.SUCCESS">
            <p class="thanks-para">You will receive a confirmation message in your inbox shortly. If you do not receive this message, please check
                your spam folder.</p>
            <br>

            <p class="thanks-para">Don't forget to add info@sdmsindia.com to your address book so that you are always the first to hear about the
                latest collections, events and news.</p>
        </div>
        <div class="thanks-content" *ngIf="status == STATUS.FAILED">
            <p class="thanks-para">Payment Failed</p>
            <br>

            <p class="thanks-para">Don't forget to add info@sdmsindia.com to your address book so that you are always the first to hear about the
                latest collections, events and news.</p>
        </div>
        <div class="thanks-button">
            <ng-content></ng-content>
            <!-- <span class="m-stack__item--middle header-right-button" *ngIf="!paymentCompleted">
                <button class="btn btn-next" style="margin:0" (click)="retryPayment()">Retry Payment</button>
            </span>
            <span class="m-stack__item--middle header-right-button">
                <button class="btn btn-next" style="margin:0" (click)="logout()">Logout</button>
            </span>


            <span class="link-text">
                <img src="images/logos/printer.png" alt="">
            </span>
            <button type="button" class="btn btn-secondary" *ngIf="paymentCompleted">Download Submitted Form</button> -->
        </div>
    </div>
</div>
<!-- <app-tp-registration currentForm=5 (retryPayment)="retryPayment()" (onLogout)="logout()" [paymentCompleted]="paymentCompleted"
  (paymentDetails)="paymentDetails"></app-tp-registration> -->